module.exports = "0b6fcc80970327a05fc0df8750480012.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/walk_roof.wav
// module id = 81
// module chunks = 0